import { confirmAlert as reactConfirmAlert } from 'react-confirm-alert';

/**
 * Ensures dialog action labels use a leading capital letter (e.g. yes → Yes, proceed → Proceed).
 */
export const capitalizeConfirmButtonLabel = (label) => {
  if (label == null || typeof label !== 'string') {
    return label;
  }
  const t = label.trim();
  if (t.length === 0) {
    return label;
  }
  return t.charAt(0).toUpperCase() + t.slice(1);
};

const formatConfirmAlertOptions = (options) => {
  if (!options || !Array.isArray(options.buttons)) {
    return options;
  }
  return {
    ...options,
    buttons: options.buttons.map((btn) => {
      if (btn == null || typeof btn.label !== 'string') {
        return btn;
      }
      return { ...btn, label: capitalizeConfirmButtonLabel(btn.label) };
    }),
  };
};

/** Same API as react-confirm-alert, with button labels normalized for QA display rules */
export const confirmAlert = (options) => {
  if (options == null) {
    return;
  }
  reactConfirmAlert(formatConfirmAlertOptions(options));
};
